import { ITenantEntitlements } from '@monetize/types/app';
import { useGetTenantById } from '../api/tenantService';
import { useAuth } from '../services/auth0';

const DEFAULT_ENTITLEMENTS: ITenantEntitlements = {
  cpqEnabled: false,
  billingEnabled: false,
  reportingEnabled: false,
  dataExportEnabled: false,
  invoiceTransformationsEnabled: false,
  usageCustomFieldsEnabled: false,
};

export const useEntitlements = () => {
  const { currentTenant } = useAuth();
  const tenantId = currentTenant?.id;
  const cachedEntitlements = currentTenant?.entitlements;

  const { data: tenant, isLoading } = useGetTenantById(tenantId ?? '', {
    enabled: !!tenantId && !cachedEntitlements,
  });

  const entitlements: ITenantEntitlements =
    tenant?.entitlements ?? cachedEntitlements ?? DEFAULT_ENTITLEMENTS;

  return {
    isLoading,
    entitlements,
    cpqEnabled: entitlements.cpqEnabled,
    billingEnabled: entitlements.billingEnabled,
    reportingEnabled: entitlements.reportingEnabled,
    dataExportEnabled: entitlements.dataExportEnabled,
    invoiceTransformationsEnabled: entitlements.invoiceTransformationsEnabled,
    usageCustomFieldsEnabled: entitlements.usageCustomFieldsEnabled,
  };
};
